export default "__VITE_ASSET__DvLVMCWM__"